import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WarehouseItemRoutes = defineRoute({
    record: {
        route: {
            path: "/warehouse-item",
            component: () => loadView(import("./WarehouseItemTable.vue")),
        },
    },
    create: {
        route: {
            path: "/warehouse-item/create/:locationId?",
            component: () => loadView(import("./WarehouseItemCreate.vue")),
        },
        build(params: { locationId?: string }) {
            if (isNotNil(params.locationId)) {
                return `/warehouse-item/create/${params.locationId}`;
            }

            return "/warehouse-item/create";
        },
    },
    update: {
        route: {
            path: "/warehouse-item/update/:id",
            component: () => loadView(import("./WarehouseItemUpdate.vue")),
        },
        build(id: string) {
            return `/warehouse-item/update/${id}`;
        },
    },
});
